import { render, staticRenderFns } from "./AddNewVendor.vue?vue&type=template&id=1a5863a8&scoped=true&"
import script from "./AddNewVendor.vue?vue&type=script&lang=js&"
export * from "./AddNewVendor.vue?vue&type=script&lang=js&"
import style0 from "./AddNewVendor.vue?vue&type=style&index=0&id=1a5863a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5863a8",
  null
  
)

export default component.exports